import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const UserManualSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<LayoutGap gap="xl">
			<div className="flex flex-col gap-4 w-full p-8 border border-(--border-subtlest) rounded bg-(--background-neutral-white) [ md:flex-row ]">
				<GovSkeleton
					height="48px"
					width="48px"
					className="py-2"
					shape="circle"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<div className="w-full">
					<GovSkeleton
						height="28px"
						width="230px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
						className="block mb-3"
					/>
					<GovSkeleton
						height="21px"
						width="98%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="100%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="95%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="20%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					height="32px"
					width="80px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<div className="flex flex-col gap-4 w-full p-8 border border-(--border-subtlest) rounded bg-(--background-neutral-white) [ md:flex-row ]">
				<GovSkeleton
					height="48px"
					width="48px"
					className="py-2"
					shape="circle"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<div className="w-full">
					<GovSkeleton
						height="28px"
						width="70%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
						className="block mb-3"
					/>
					<GovSkeleton
						height="21px"
						width="100%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="90%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="98%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
					<GovSkeleton
						height="21px"
						width="70%"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					height="32px"
					width="80px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
		</LayoutGap>
	);
};
